<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
    <div
      v-for="(element, index) in elements"
      :key="element.id || index"
      class="flex items-center box p-4 sm:p-6 gap-6 md:gap-6 lg:px-16"
    >
      <div class="flex-shrink-0" :class="element.imageStyle">
        <img
          :src="element.imageSrc"
          :alt="element.imageAlt"
          class="w-full h-full object-cover"
        />
      </div>

      <div class="">
        <h3 class="text-xl lg:text-2xl font-semibold mb-3">
          {{ element.title }}
        </h3>
        <p class="text-base text-gray-900 mb-4">
          {{ element.text }}
        </p>
        <a :href="element.seeMoreUrl" class="link flex items-center gap-2">
          See more
          <font-awesome-icon :icon="['fas', 'arrow-right']" class="w-4 h-4" />
        </a>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    elements: {
      type: Array,
      required: true,
    },
  },
};
</script>
